var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{staticClass:"user-name font-weight-bolder mb-0 mr-1",staticStyle:{"color":"white"}},[_vm._v(" "+_vm._s(_vm.profile.name)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }